import { grantStatus } from "../../../../../utils/Enums/grantStatus";
import { getStatusColor } from "../../../../../utils/outorga/dashboard";
import styles from "../GrantReport.module.css";

export default function GrantReportTable({ data }) {
    const hasData = data && data.length > 0;

    return (
        <div className={styles.reportTableContainer}>
            <h5 className={styles.reportTableContainerTitle}>Relatório de Outorga</h5>
            {!hasData ? (
                <div className={styles.noDataMessage}>
                    <p>Sem dados no momento.</p>
                </div>
            ) : (
                data.map((grant, i) => (
                    <details open className="custom-summary" style={{ marginBottom: '1rem' }}>
                        <summary>{grant.name}</summary>
                        <div key={i} className={styles.reportTableContainerWrapper}>
                            <table className="table afira-table">
                                <thead>
                                    <tr>
                                        <th>Descrição</th>
                                        <th>Monitorado</th>
                                        <th>Captação</th>
                                        <th>ID Ref</th>
                                        <th>Validade</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td title={grant?.name}>{grant?.name}</td>
                                        <td title={grant?.info?.monitored}>{grant?.info?.monitored}</td>
                                        <td title={grant?.info?.captation}>{grant?.info?.captation}</td>
                                        <td title={grant?.info?.refId}>{grant?.info?.refId}</td>
                                        <td title={grant?.info?.validity}>{grant?.info?.validity}</td>
                                        <td title={grantStatus[grant?.grantStatus]}>{grantStatus[grant?.grantStatus]}</td>
                                    </tr>
                                </tbody>
                            </table>

                            <table className="table afira-table">
                                <thead>
                                    <tr>
                                        <th>Parâmetro</th>
                                        <th>Alerta</th>
                                        <th>Crítico</th>
                                        <th>Excedido</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {grant.fields?.map((field, index) => (
                                        <tr key={index}>
                                            <td title={field?.name}>{field?.name}</td>
                                            <td title={field?.alert}>{field?.alert}</td>
                                            <td title={field?.critical}>{field?.critical}</td>
                                            <td title={field?.exceeded}>{field?.exceeded}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            {grant?.months?.map((month, monthIndex) => (
                                <details
                                    open
                                    key={`mes-${grant?.name}-${monthIndex}`}
                                    className="custom-summary"
                                    style={{ marginBottom: '1rem' }}
                                >
                                    <summary>
                                        {month?.name}
                                        {`
                                            - ${month?.totalMonthViolations ?? 0}
                                            ${month?.totalMonthViolations == 1 ? "Dia com violação" : "Dias com violações"}
                                        `}
                                    </summary>
                                    <div className={styles.reportTableContainerWrapper} key={monthIndex}>
                                        {month?.days?.map((day, dayIndex) => (
                                            <table key={dayIndex} className="table afira-table">
                                                <thead>
                                                    <tr
                                                        className={day?.noOccurrences ? styles.reportTableContainerWrapperTableNoViolationsRow : null}
                                                        style={{ '--no-violation-status-color': getStatusColor(day?.status) }}
                                                    >
                                                        <th colSpan={5}>
                                                            {day?.date} - {
                                                                day?.noOccurrences ?
                                                                    day?.status_name :
                                                                    `
                                                                        ${day?.totalViolations}
                                                                        ${day?.totalViolations == 1 ? "Parâmetro com violação" : "Parâmetros com violações"}
                                                                        (${day?.status_name})
                                                                    `
                                                            }
                                                        </th>
                                                    </tr>

                                                    {!day?.noOccurrences && (
                                                        <tr>
                                                            <th>Parâmetro</th>
                                                            <th>Valor</th>
                                                            <th>Acima</th>
                                                            <th>Status</th>
                                                        </tr>
                                                    )}
                                                </thead>

                                                <tbody>
                                                    {day?.noOccurrences ? (
                                                        null
                                                    ) : (
                                                        day?.violations?.map((violation, i) => (
                                                            <tr
                                                                key={i}
                                                                className={styles.reportTableContainerWrapperTableViolationRow}
                                                                style={{ '--status-color': getStatusColor(violation?.status) }}
                                                            >
                                                                <td title={violation?.name}>{violation?.name}</td>
                                                                <td title={violation?.value}>{violation?.value}</td>
                                                                <td title={violation?.above}>{violation?.above}</td>
                                                                <td title={grantStatus[violation?.status]}>{grantStatus[violation?.status]}</td>
                                                            </tr>
                                                        ))
                                                    )}
                                                </tbody>
                                            </table>
                                        ))}
                                    </div>
                                </details>
                            ))}
                        </div>
                    </details>
                ))
            )}
        </div>
    );
}